document.addEventListener('DOMContentLoaded', function(){

    const cards = document.querySelectorAll('#our-products .our-products__card');

    cards.forEach(card => {
        const toggleMoreButton = card.querySelector('[data-toggle-more-button]');
        const toggleMoreContent = card.querySelector('[data-toggle-more-content]');

        toggleMoreButton.addEventListener('click', function(e){
            e.preventDefault();

            // toggle off all others
            cards.forEach(card => {
                const toggleMoreButton = card.querySelector('[data-toggle-more-button]');
                const toggleMoreContent = card.querySelector('[data-toggle-more-content]');

                toggleMoreContent.classList.add('text-truncate-lines-4');
                toggleMoreButton.classList.remove('d-none');
            });

            // toggle on current
            toggleMoreContent.classList.remove('text-truncate-lines-4');
            toggleMoreButton.classList.add('d-none');

            window.scrollTo({
                top: card.getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height + 10), 
                behavior: 'smooth'
            });
        });
    });

});